// extracted by mini-css-extract-plugin
module.exports = {"root":"Initials_root__30JPI","rootSmall":"Initials_rootSmall__2dGOC","spinWrapper":"Initials_spinWrapper__17MLQ"};